// extracted by mini-css-extract-plugin
export default {"CentreSelectorContainer":"index_CentreSelectorContainer__2ymqv"};